import { Component, Input } from '@angular/core';
import { Dashboard } from '../../models/dashboard.model';

@Component({
  selector: 'app-timeline-chart',
  templateUrl: './timeline-chart.component.html',
  styleUrls: ['./timeline-chart.component.css']
})
export class TimelineChartComponent {

  private static readonly DAY_IN_MILLIS: number = 86400000;

  @Input() dashboard: Dashboard;

  @Input() locale: string;

  reportDate: number = Date.now();

  get displayAll(): boolean {
    return !!this.dashboard.getMeasurementStartDate() &&
      !!this.dashboard.getMeasurementEndDate() &&
      !!this.dashboard.getMeasurementPeriod() &&
      !!this.dashboard.getDiscountStartDate() &&
      !!this.dashboard.getDiscountEndDate() &&
      !!this.dashboard.getDiscountPeriod() &&
      !!this.dashboard.getNextMeasurementStartDate() &&
      !!this.dashboard.getNextMeasurementEndDate() &&
      !!this.dashboard.getNextMeasurementPeriod() &&
      !!(this.dashboard.getNextMeasurementStartDateOffset() || this.isOffsetZero) &&
      !!this.dashboard.getNextDiscountStartDate() &&
      !!this.dashboard.getNextDiscountEndDate() &&
      !!this.dashboard.getNextDiscountPeriod();
  }

  get displayOnlyNextPeriods(): boolean {
    return !!this.dashboard.getNextMeasurementStartDate() &&
      !!this.dashboard.getNextMeasurementEndDate() &&
      !!this.dashboard.getNextMeasurementPeriod() &&
      !!(this.dashboard.getNextMeasurementStartDateOffset() || this.isOffsetZero) &&
      !!this.dashboard.getNextDiscountStartDate() &&
      !!this.dashboard.getNextDiscountEndDate() &&
      !!this.dashboard.getNextDiscountPeriod();
  }

  get currentPeriodsOffset(): number {
    return this.dashboard.getNextMeasurementStartDateOffset()! + this.dashboard.getNextMeasurementPeriod()! + this.dashboard.getNextDiscountPeriod()! - this.dashboard.getMeasurementPeriod()! - this.dashboard.getDiscountPeriod()!;
  }

  get nextPeriodsOffset(): number {
    return this.dashboard.getNextMeasurementStartDateOffset()!;
  }

  get leftPercentage(): number {
    if (this.dashboard.getReviewFlag() == 'Y') {
      if (this.isBetween()) {
        return (this.reportDate - this.dashboard.getDiscountStartDate()!) / (this.dashboard.getDiscountEndDate()! + TimelineChartComponent.DAY_IN_MILLIS - this.dashboard.getDiscountStartDate()!) * 100;
      }
    } else if (this.dashboard.getActiveRampUpPeriodFlag() == 'Y') {
      return (this.reportDate - this.dashboard.getRampUpStartDate()!) / (this.dashboard.getRampUpEndDate()! + TimelineChartComponent.DAY_IN_MILLIS - this.dashboard.getRampUpStartDate()!) * 100;
    } else if (this.dashboard.getActiveInitialDiscountPeriodFlag() == 'Y') {
      return (this.reportDate - this.dashboard.getInitialDiscountStartDate()!) / (this.dashboard.getInitialDiscountEndDate()! + TimelineChartComponent.DAY_IN_MILLIS - this.dashboard.getInitialDiscountStartDate()!) * 100;
    }
    return -1;
  }

  get rightPercentage(): number {
    if (this.dashboard.getReviewFlag() == 'Y') {
      if (this.isBetween()) {
        return 100 - ((this.reportDate - this.dashboard.getDiscountStartDate()!) / (this.dashboard.getDiscountEndDate()! + TimelineChartComponent.DAY_IN_MILLIS - this.dashboard.getDiscountStartDate()!) * 100);
      }
    } else if (this.dashboard.getActiveRampUpPeriodFlag() == 'Y') {
      return 100 - ((this.reportDate - this.dashboard.getRampUpStartDate()!) / (this.dashboard.getRampUpEndDate()! + TimelineChartComponent.DAY_IN_MILLIS - this.dashboard.getRampUpStartDate()!) * 100);
    } else if (this.dashboard.getActiveInitialDiscountPeriodFlag() == 'Y') {
      return 100 - ((this.reportDate - this.dashboard.getInitialDiscountStartDate()!) / (this.dashboard.getInitialDiscountEndDate()! + TimelineChartComponent.DAY_IN_MILLIS - this.dashboard.getInitialDiscountStartDate()!) * 100);
    }
    return -1;
  }

  get discountEndNextDay(): number {
    return this.dashboard.getDiscountEndDate()! + TimelineChartComponent.DAY_IN_MILLIS;
  }

  get isOffsetZero(): boolean {
    return this.dashboard.getNextMeasurementStartDateOffset() === 0;
  }

  private isBetween(reportDate: number = this.reportDate): boolean {
    return reportDate >= this.dashboard.getDiscountStartDate()! && reportDate <= (this.dashboard.getDiscountEndDate()! + TimelineChartComponent.DAY_IN_MILLIS);
  }

  public getNextPeriodOffset(): number {
    if (this.dashboard.getActiveInitialDiscountPeriodFlag() == 'Y' || this.dashboard.getActiveRampUpPeriodFlag() == 'Y') {
      return new Date(this.dashboard.getNextMeasurementStartDate()!).getMonth() - new Date(this.dashboard.getRampUpStartDate()!).getMonth() % 12;
    } else {
      return this.nextPeriodsOffset;
    }
  }

  public getCurrentPeriodOffset(): number {
    if (this.dashboard.getActiveInitialDiscountPeriodFlag() == 'Y' || this.dashboard.getActiveRampUpPeriodFlag() == 'Y') {
      return new Date(this.dashboard.getNextDiscountEndDate()!).getMonth() - new Date(this.dashboard.getInitialDiscountEndDate()!).getMonth() % 12;

    } else {
      return this.currentPeriodsOffset;
    }
  }

  public getMonthAfterInitialDiscountEnd(): number {
    return new Date(this.dashboard.getInitialDiscountEndDate()! + TimelineChartComponent.DAY_IN_MILLIS).getTime();
  }
}

